import React from 'react'
import './style.scss'

export default function AddressDescription() {
    return (
        <div data-testid="footerText" className="footer-bottom-text">
           <p>©Marca registrada. Todos los derechos reservados.
            <br />
            Av. Javier Prado Este Nro. 6210 Oficina 501 La Molina, Lima.
            </p> 
            <p>
            SANTANDER EMPRESA ADMINISTRADORA DE FONDOS COLECTIVOS S.A.

            </p>
        </div>
    )
}